import { render } from "./header-search-mobile.vue?vue&type=template&id=20bdd88c"
import script from "./header-search-mobile.vue?vue&type=script&lang=js"
export * from "./header-search-mobile.vue?vue&type=script&lang=js"

import "./header-search-mobile.vue?vue&type=style&index=0&id=20bdd88c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__